import React, { useEffect, useMemo, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import searchIcon from "../../../assets/images/icons/search-icon.svg"
import downArrowIcon from "../../../assets/images/icons/down-arrow-color.svg"
import eye from "../../../assets/images/icons/eye.svg"
import close from "../../../assets/images/icons/close.svg"
import closeRed from "../../../assets/images/icons/close-icon-red.svg"
import TableContainer from "components/Common/TableContainer"
import { Link } from "react-router-dom"
import {
  formatAmount,
  getIcdRequestStatus,
  getIcdsStatus,
  getTableSortingHeaderIcon,
} from "helpers/common"
import { useLazyGetAdminOffersDashboardQuery } from "store/api/reports/reports"
import InvestorRequestViewModel from "pages/Dashboard/AdminDashboard/InvestorRequestViewModel"
import { useSelector } from "react-redux"
import moment from "moment"

const defaultFilters = {
  page: 1,
  pageSize: 20,
}
const periods = [
  "This Year",
  "This Half Year",
  "This Quarter",
  "This Month",
  "This Week",
]
const DashboardFundRequests = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [isGlobalFilter, setIsGlobalFilter] = useState(false)
  const [activeTab, setActiveTab] = useState("ADMIN")
  const toggle = () => setDropdownOpen((prevState) => !prevState)
  const [filters, setFilters] = useState(defaultFilters)
  const [period, setPeriod] = useState("This Year")
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false)
  const [selectedIcdId, setSelectedIcdId] = useState("")
  const [getResults, { isFetching }] = useLazyGetAdminOffersDashboardQuery()
  const { currentUserMenuType } = useSelector((state) => state.common)

  const getList = async () => {
    try {
      const { data } = await getResults({
        created_by: activeTab,
        period,
      }).unwrap()
      setData(data)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [activeTab, period])

  const columns = useMemo(() => [
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
      accessorKey: "formatted_created_at",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, "Investor Detail"),
      accessorKey: "investor_name",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <p
          title={row?.original?.investor?.name}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "180px",
            marginBottom: "0",
          }}
        >
          {row?.original?.investor?.name}
        </p>
      ),
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "ROI"),
      accessorKey: "interest_rate",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => <div>{row?.original.interest_rate} %</div>,
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Amount"),
      accessorKey: "amount",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => <div>₹ {formatAmount(row?.original?.amount)}</div>,
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Maturity"),
      accessorKey: "tenure",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <>{moment(row?.original.repayment_date).format("D MMM YYYY")}</>
      ),
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Status"),
      accessorKey: "status",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => {
        return (
          <div className="code-status">
            {getIcdRequestStatus(row?.original?.status)}
          </div>
        )
      },
    },
    {
      id: "action",
      header: "Actions",
      cell: ({ row }) => (
        <div className="d-flex justify-content-center align-items-center gap-3">
          <div className="action-view">
            <img
              src={eye}
              alt=""
              onClick={() => {
                setOpen(true)
                setSelectedIcdId(row?.original.id)
              }}
            />
          </div>
        </div>
      ),
    },
  ])

  return (
    <React.Fragment>
      <div className="table-section-wrapper">
        <div className="table-top-section">
          <h6>Fund Request</h6>
          <div
            className={`tab-section ${currentUserMenuType === "WEALTH_PARTNER" ? "wealth-patner-tab" : ""}`}
          >
            <p
              onClick={() => setActiveTab("ADMIN")}
              className={activeTab === "ADMIN" ? "active" : ""}
            >
              Prachay's Offer
            </p>
            <p
              onClick={() => setActiveTab("INVESTOR")}
              className={activeTab === "INVESTOR" ? "active" : ""}
            >
              Investor's Offer
            </p>
          </div>
          <div className="search-box-wrapp">
            <div
              className={`search-box-section`}
              onClick={() => setIsGlobalFilter(!isGlobalFilter)}
            >
              <img
                src={isGlobalFilter ? closeRed : searchIcon}
                alt=""
                height={16}
              />
            </div>
            <div className="dropdown-section">
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret size="lg">
                  {period} <img src={downArrowIcon} alt="" />
                </DropdownToggle>
                <DropdownMenu
                  style={{
                    minWidth: "auto",
                  }}
                >
                  {periods.map((item, index) => (
                    <DropdownItem
                      key={`periods_${index}`}
                      onClick={() => setPeriod(item)}
                    >
                      {item}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="dashboard-table-wrapper">
          <TableContainer
            showSerialNo={false}
            filters={filters}
            setFilters={setFilters}
            columns={columns}
            isLoading={isFetching}
            data={data}
            isGlobalFilter={isGlobalFilter}
            isCustomPageSize={false}
            isPagination={false}
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
      <InvestorRequestViewModel
        openInvestorRequest={open}
        setOpenInvestorRequest={(v) => {
          setOpen(v)
          getList()
        }}
        id={selectedIcdId}
        offerType={activeTab}
      />
    </React.Fragment>
  )
}

export default DashboardFundRequests
